import fetchDownload from '../../../services/GetDownload.jsx';
import { DownloadFileFunc } from '../../../types';
import { buildDownloadEndpoint, buildDownloadFiltersEndpoint } from '../../../utils/buildDownloadEndpoint';
import JSZip from 'jszip';

export async function fetchDownloadFile({
  extension,
  columnVisibilityModel,
  view,
  source = '',
  tab,
  searchItems,
  titleGrid,
  isAuthenticated,
  authorization,
  isEvidence,
  isMapping,
  mappingContent,
}: DownloadFileFunc & {
  filters?: Record<string, any>;
  totalResults?: number;
}): Promise<void> {
  let url = buildDownloadEndpoint({
    extension,
    columnVisibilityModel,
    view,
    source,
    tab,
    searchItems,
    isEvidence,
    isMapping,
    mappingContent,
  });

  if (!isAuthenticated) {
    url += '&skey=unauth';
  }

  const blob = await fetchDownload(url, authorization);
  const blobUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = blobUrl;

  const fileName = `${view}_${titleGrid}_${tab}_${source}_${searchItems!.map(i => i.id).join('-')}.${extension}`;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

//TODO: Replace the function above fot this one in TR-116
export async function fetchDownloadFiltersFile({
  extension,
  columnVisibilityModel,
  view,
  source = '',
  tab,
  searchItems,
  titleGrid,
  isAuthenticated,
  authorization,
  isEvidence,
  isMapping,
  mappingContent,
  filters = {},
  totalResults = 0,
  filterValue,
}: DownloadFileFunc & {
  filters?: Record<string, any>;
  totalResults?: number;
}): Promise<void> {
  let url = buildDownloadFiltersEndpoint({
    extension,
    columnVisibilityModel,
    view,
    source,
    tab,
    searchItems,
    isEvidence,
    isMapping,
    mappingContent,
    filters,
  });

  if (!isAuthenticated) {
    url += '&skey=unauth';
  }

  const dataBlob = await fetchDownload(url, authorization);

  const searchInfo = createSearchInfoContent({
    searchItems,
    view,
    isEvidence,
    source,
    tab,
    totalResults,
    filterArray: filterValue,
    columnVisibilityModel,
    isMapping,
    mappingContent,
  });

  const zip = new JSZip();

  const dataFileName = `search_result_${searchItems!.map(i => i.id).join('-')}.${extension}`;
  const infoFileName = `search_info_${searchItems!.map(i => i.id).join('-')}.txt`;

  zip.file(dataFileName, dataBlob);
  zip.file(infoFileName, searchInfo);

  const zipBlob = await zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 6 },
  });

  const zipUrl = window.URL.createObjectURL(zipBlob);
  const link = document.createElement('a');
  link.href = zipUrl;
  link.setAttribute('download', `search_${searchItems!.map(i => i.id).join('-')}.zip`);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => {
    window.URL.revokeObjectURL(zipUrl);
  }, 1000);
}

function createSearchInfoContent({
  searchItems,
  view,
  isEvidence,
  source,
  tab,
  totalResults,
  filterArray,
  columnVisibilityModel,
  isMapping,
  mappingContent,
}) {
  const formattedFilters = formatFiltersFromArray(filterArray);

  return `SEARCH INFORMATION
==================

Download Date:       ${new Date().toLocaleString()}

SEARCH DETAILS
--------------
Search Terms:        
      name: ${searchItems?.map(item => item.name).join(', ') || 'N/A'}
      symbol: ${searchItems?.map(item => item.symbol).join(', ') || 'N/A'}
      ID: ${searchItems?.map(item => item.id).join(', ') || 'N/A'}
Analysis Type:       ${view}
Data Type:           ${isEvidence ? 'Evidence' : 'Summary'}
Source:              ${source.replace('_', ' ')}
Tab:                 ${tab}
Total Results:       ${totalResults}

FILTERS APPLIED
---------------
${formattedFilters}

DISPLAY SETTINGS
----------------
Visible Columns:     ${
    columnVisibilityModel
      ? Object.entries(columnVisibilityModel)
          .filter(([_, visible]) => visible)
          .map(([col, _]) => col)
          .join(', ')
      : 'All'
  }

==================`;
}

function formatFiltersFromArray(filterArray) {
  if (!filterArray || filterArray.length === 0) return 'None';

  return filterArray
    .map(({ name, value, operator }) => {
      if (value === null || value === undefined || value === '') return null;

      switch (operator) {
        case 'gt':
          return `${name}: > ${value}`;
        case 'lt':
          return `${name}: < ${value}`;
        case 'between':
          return Array.isArray(value)
            ? `${name}: between ${value[0]} and ${value[1]}`
            : `${name}: between ${value}`;
        case 'equals':
        default:
          return `${name}: ${value}`;
      }
    })
    .filter(Boolean)
    .join('\n');
}
